module.exports = __webpack_public_path__ + "assets/img/3.eddbe9cc.jpeg";